/**
 * Replacement for granguard-web's Clerk-backed name lookup.
 * ScamDefense has no auth, so the greeting is a generic placeholder.
 *
 * Some chapters (e.g. the credit-letter slide) personalize a fake letter
 * using the learner's first name to make the lesson feel real. We could
 * later prompt anonymously on the first slide and stash the answer in
 * localStorage; for now, "Customer" is a safe default.
 */
export function useGreetingName(): string {
  if (typeof window === 'undefined') return 'Customer'
  try {
    const stored = window.localStorage.getItem('sd_first_name')
    if (stored && stored.trim().length > 0) return stored.trim()
  } catch {
    // ignore
  }
  return 'Customer'
}
